<template>
	<div class="networkroom">

		<div class="tipcon">
			<div :class="sign == 1?'title_cur':'title'" @click="changetab(1)">鼓号队学习</div>
			<div :class="sign == 2?'title_cur':'title'" @click="changetab(2)">主题队课</div>
		</div>

		<div style="min-height: 6rem;">
			<div class="listcon">
				<div class="signle" v-for="(item,index) in youthteamllist" :key="index"
				@click="todetail(item)">
					<div class="img_c">
						<el-image fit='cover' class="img" :src="$imgUrl + item.cover_dictText" alt=""></el-image>
					</div>
					<div class="inform_c">
						<div class="title overfh" :title="item.title">{{item.title || ''}}</div>
						<div class="describe overfh">{{gethypertext(item.introduction)}}</div>
						<div class="time">{{item.createTime || ''}}</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 分页 -->
		<div class="">
			<div is='footPage' class="zhini-pagination"
			  :currentPage="pageNo"
			  :totalPage="total"
				 ref="foot"
			  @pageNum="pageNum"  :pagesize='pageSize'></div>
		</div>

	</div>

</template>

<script>

import footPage from '../components/footpage/footpage.vue'
export default {
  components: {
  	  footPage,
  },

  data: function() {
    return {
		youthteamllist:[],
        sign:1,
	    pageNo:1,
	    total:5,
	    pageSize:10,

    };
  },

  mounted() {
	  if(this.$route.query.type){ 
		  this.sign=this.$route.query.type
	  }
		this.getYouthTeam()
  },

  methods: {
	    //少年队网络视频
	    getYouthTeam(){
			this.$get(`web/teaching/list?pageSize=10&pageNo=${this.pageNo}&teachType=${this.sign}`).then(res=>{
				  if(res.success){
						this.youthteamllist = res.result.records
						this.total = res.result.total
				  }
			})
	    },

	    todetail(item){
			this.$router.push({ path: '/networkroomdetail?id=' + item.id });
		},

		changetab(sign){
			this.sign = sign
			this.pageNo = 1
			this.$refs.foot.chooseIndex = 1
			this.getYouthTeam()
		},

		pageNum(e) {
			this.pageNo = e;
			this.$onScrollT()
			this.getYouthTeam()
		},

		//过滤富文本
		gethypertext(str){
			if(str == null){
				return "";
			}
			var str = str.replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, "").replace(/&rdquo;/gi, "")
			              .replace(/&ldquo;/gi, "").replace(/\n/gi, "").replace(/&hellip;/gi, "").replace(/&mdash;/gi, "");
			// str = str.substring(0,50);
			return str;
		},

  },


};
</script>

<style scoped="scoped" lang="scss">

.networkroom{

	.tipcon{
		height: 80px;
		display: flex;
		align-items: center;
		justify-content: center;
		.title{
			cursor: pointer;
			width: 253px;
			height: 50px;
			line-height: 50px;
			text-align: center;
			font-size: 20px;
			font-weight: 400;
			color: #333333;
			margin-left: 20px;
			margin-right: 20px;
		}
		.title_cur,.title:hover{
			cursor: pointer;
			width: 253px;
			height: 50px;
			line-height: 50px;
			text-align: center;
			background: #E81414;
			border-radius: 25px;
			font-size: 20px;
			font-weight: 400;
			color: #FFFFFF;
			margin-left: 20px;
			margin-right: 20px;
		}

	}

	.listcon{
		margin-top: 40px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		.signle{
			cursor: pointer;
			width: 49%;
			margin-bottom: 20px;
			display: flex;
			flex-flow: wrap;
			overflow: hidden;
			.img_c{
				.img{
					width: 183px;
					height: 118px;
				}
			}
			.inform_c{
				margin-left: 20px;
				font-weight: 400;
				width: calc(100% - 203px);
				.title{
					font-size: 18px;
					color: #333333;
					margin-bottom: 10px;
				}
				.describe{
					font-size: 16px;
					color: #666666;
					margin-bottom: 20px;
				}
				.time{
					font-size: 14px;
					color: #666666;
				}
			}
		}

	}


}

</style>
